import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: '',
  isRememberId: false,
  isStaySignedIn: false,
  isTrustDevice: false,
  redirectUrl: '',
  temporaryId: ''
}

export const iamSlice = createSlice({
  name: 'iam',
  initialState,
  reducers: {
    setId(state, action: PayloadAction<string>) {
      state.id = action.payload
    },
    setRedirectUrl(state, action: PayloadAction<string>) {
      state.redirectUrl = action.payload
    },
    setTemporaryId(state, action: PayloadAction<string>) {
      state.temporaryId = action.payload
    }
  }
})

export const { setId, setRedirectUrl, setTemporaryId } = iamSlice.actions

export default iamSlice
